import { render, staticRenderFns } from "./website.vue?vue&type=template&id=dfbadcbe&"
var script = {}
import style0 from "./website.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports